import { createFileRoute } from '@tanstack/react-router';

import { PublicProfilePage } from '@/features/profiles/public-profile-page';
import { bootSession } from '@/lib/auth/session';

/** Public: a company's published profile (shareable; signing in adds the actions). */
export const Route = createFileRoute('/c/$slug')({
  beforeLoad: async () => {
    // Best effort: a signed-in person gets the actions, everyone else the page.
    await bootSession().catch(() => undefined);
  },
  component: PublicCompanyRoute,
});

function PublicCompanyRoute() {
  const { slug } = Route.useParams();
  return <PublicProfilePage slug={slug} />;
}
